import Success from '../icons/Success';
import classes from './Button.module.scss';

interface ButtonProps {
	clazz?: string;
	children: string | React.ReactNode;
	type?: 'button' | 'submit' | 'reset' | undefined;
	success?: boolean;
	icon?: React.ReactNode;
	disabled?: boolean;
	onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	theme?: 'default' | 'outline' | 'outline-shadow' | 'fill';
}

const Button = ({
	clazz,
	children,
	type = 'button',
	success = false,
	icon,
	disabled = false,
	onClick,
	theme = 'default',
}: ButtonProps) => {
	return (
		<button
			type={type}
			disabled={disabled}
			className={`${classes.button} ${classes[theme]} ${
				success ? classes['button--success'] : ''
			} ${clazz || ''}`}
			onClick={(e) => (onClick ? onClick(e) : undefined)}
		>
			{icon || (success && <Success />)}
			<span className={classes.text}>{children}</span>
		</button>
	);
};

export default Button;
